import { Component, forwardRef, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem, ConfirmationService} from 'primeng/primeng';


import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';

//constants
import { Constants }         from '../../constants/Constants';


@Component({
  selector: 'my-usermessage-edit',
  templateUrl: './UserMessageEdit.component.html'
})
export class UserMessageEditComponent implements OnInit {

    public msgs: Message[] = [];
    public userMessage: ent.UserMessage;
    userInfo: ent.UserInfo;

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;

    
    displayConfirmEmailDialog: boolean;

    constructor(private adminService: serv.AdminService, private domainDataService: serv.DomainDataService, private authenticationService: serv.AuthenticationService) 
    {
        
    }

    ngOnInit(): void {
      this.userInfo = this.authenticationService.getUserInfo();
      this.load();
    }

    load(){
      let request: ent.GetDataRequest = {Employee: this.userInfo.Employee};
      this.domainDataService.getUserMessages(request).subscribe(x=>{
        if (x.length > 0){
          this.userMessage = x[0];
        }
      })

    }

    onSaveClick(event: any){

      let request: ent.SaveUserMessageRequest = {UserMessage: this.userMessage, SavedByEmployee: this.userInfo.Employee};
      this.adminService.saveUserMessage(request).subscribe(x=>{
        this.messageHandlerComponent.handleResponse(x);
      })
    }

    onCancelClick(event: any){
      this.load();
    }

}